const a = /* @__PURE__ */ new Set(), e = (d) => {
  a.add(d);
}, c = (d) => a.has(d), o = (d) => {
  a.add(d);
};
export {
  o as addExistingImageSrc,
  e as addUploadedImageSrc,
  c as hasUploadedImageSrc
};
